// Mounted once for the whole app: every Hub table reads as cards on a phone,
// with its key columns visible (audit 2026-10-27, S1-M14 / S2-M11 / S3-M15).
// See card-table.ts for the rule and why the observer adopts tables itself.
// Renders nothing. A table that is added or re-rendered later is adopted on
// the next frame; above 720px the `mkt-tbl--cards` class changes nothing.

import { useEffect } from "react";

import { adoptCardTables } from "./card-table";

export function HubTableCards() {
  useEffect(() => {
    if (typeof document === "undefined" || typeof MutationObserver === "undefined") return;
    let frame = 0;
    const run = () => {
      frame = 0;
      adoptCardTables(document);
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(run);
    };
    run();
    const observer = new MutationObserver(schedule);
    // A React re-render that rewrites a table's className drops the class added here, so watch that too.
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
    return () => {
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
  return null;
}
